/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Nachrueckpossible1Inputs */

const en__field_nachrueckpossible1 = /** @type {(inputs: _Field_Nachrueckpossible1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`moving up possible`)
};

const de__field_nachrueckpossible1 = /** @type {(inputs: _Field_Nachrueckpossible1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nachrücken möglich`)
};

/**
* | output |
* | --- |
* | "moving up possible" |
*
* @param {_Field_Nachrueckpossible1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_nachrueckpossible1 = /** @type {((inputs?: _Field_Nachrueckpossible1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Nachrueckpossible1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_nachrueckpossible1(inputs)
	return de__field_nachrueckpossible1(inputs)
});
export { _field_nachrueckpossible1 as "_field_nachrueckPossible" }